import { fetcher } from "helpers/fetcher";

import { TDeleteFacilitiesReq, TDeleteFacilitiesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteFacilities = async (payload: TDeleteFacilitiesReq) => {
  return await fetcher<TDeleteFacilitiesRes, TDeleteFacilitiesReq["data"]>(
    ENDPOINT.CORPORATION.DELETE_ORGANIZATION_FACILITY,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.DELETE_ORGANIZATION_FACILITY.version,
        [API_HEADER.CORP_ID]: payload.idCorp,
      },
    }
  );
};

export const mutationDeleteFacilities = async (
  payload: TDeleteFacilitiesReq
) => {
  return (await deleteFacilities(payload)).data;
};

mutationDeleteFacilities._key = (payload: TDeleteFacilitiesReq) => [
  ENDPOINT.CORPORATION.DELETE_ORGANIZATION_FACILITY.url,
  payload,
];
